const styles = theme => ({
  root: {
    width: '100%',
    textAlign:'center'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/results/views/wiremap/voltagediagram/styles.js